import api from "!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-1[0].rules[0].use[1]!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-1[0].rules[0].use[2]!../../node_modules/postcss-loader/dist/cjs.js!./tailwind.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};